// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.App {
  min-height: 100vh;
}

/* ===== Kitchen TV Mode =====
   Targets Smart TVs and large displays. Enlarges fonts so cooks can read
   the dashboard from several metres away. Applied via body.kitchen-tv-mode
   class added in KitchenDashboardNew when ?tv=1 query param is present. */
body.kitchen-tv-mode {
  cursor: none; /* hide cursor on TV screens */
}
body.kitchen-tv-mode .kitchen-tv {
  font-size: 20px;
  line-height: 1.35;
}
body.kitchen-tv-mode .kitchen-tv h1 {
  font-size: 2.4rem;
}
body.kitchen-tv-mode .kitchen-tv h2,
body.kitchen-tv-mode .kitchen-tv h3 {
  font-size: 1.6rem;
}
body.kitchen-tv-mode .kitchen-tv .text-xs {
  font-size: 0.95rem;
}
body.kitchen-tv-mode .kitchen-tv .text-sm {
  font-size: 1.1rem;
}
body.kitchen-tv-mode .kitchen-tv .text-base {
  font-size: 1.25rem;
}
body.kitchen-tv-mode .kitchen-tv .text-lg {
  font-size: 1.5rem;
}
body.kitchen-tv-mode .kitchen-tv .text-2xl {
  font-size: 2rem;
}
body.kitchen-tv-mode .kitchen-tv button {
  font-size: 1.05rem;
  padding: 10px 16px;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #e92587;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #d11f73;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;0EAG0E;AAC1E;EACE,YAAY,EAAE,8BAA8B;AAC9C;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* ===== Kitchen TV Mode =====\n   Targets Smart TVs and large displays. Enlarges fonts so cooks can read\n   the dashboard from several metres away. Applied via body.kitchen-tv-mode\n   class added in KitchenDashboardNew when ?tv=1 query param is present. */\nbody.kitchen-tv-mode {\n  cursor: none; /* hide cursor on TV screens */\n}\nbody.kitchen-tv-mode .kitchen-tv {\n  font-size: 20px;\n  line-height: 1.35;\n}\nbody.kitchen-tv-mode .kitchen-tv h1 {\n  font-size: 2.4rem;\n}\nbody.kitchen-tv-mode .kitchen-tv h2,\nbody.kitchen-tv-mode .kitchen-tv h3 {\n  font-size: 1.6rem;\n}\nbody.kitchen-tv-mode .kitchen-tv .text-xs {\n  font-size: 0.95rem;\n}\nbody.kitchen-tv-mode .kitchen-tv .text-sm {\n  font-size: 1.1rem;\n}\nbody.kitchen-tv-mode .kitchen-tv .text-base {\n  font-size: 1.25rem;\n}\nbody.kitchen-tv-mode .kitchen-tv .text-lg {\n  font-size: 1.5rem;\n}\nbody.kitchen-tv-mode .kitchen-tv .text-2xl {\n  font-size: 2rem;\n}\nbody.kitchen-tv-mode .kitchen-tv button {\n  font-size: 1.05rem;\n  padding: 10px 16px;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #e92587;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #d11f73;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
